import React from 'react';
import { SelectRender } from '../tools/select';
import DropdownList from '../DropdownList';
import Selector from '../Selector';
import DropdownOption from '../DropdownOption';
import SelectOptions from '../SelectOptions';
import { getObjectValue } from '../tools/util';
export default SelectRender(function (_ref, _ref2, _ref3) {
  var _triggerNode$offsetWi;

  var change = _ref.change,
      selected = _ref.value,
      open = _ref.open,
      setOpen = _ref.setOpen,
      triggerNode = _ref.triggerNode;
  var _ref2$data = _ref2.data,
      data = _ref2$data === void 0 ? [] : _ref2$data,
      optionEcho = _ref2.optionEcho,
      isOptionDisabled = _ref2.isOptionDisabled,
      allowClear = _ref2.allowClear,
      optionRender = _ref2.optionRender;
  var getValue = _ref3.getValue,
      _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options,
      searchProps = _ref3.searchProps,
      dropdownHeight = _ref3.dropdownHeight;
  var selectedItem = data.find(function (item) {
    return getValue(item) === selected;
  });
  return {
    selector: {
      Component: Selector,
      props: {
        allowClear: allowClear,
        onClick: function onClick() {
          setOpen(!open);
        },
        onClear: function onClear() {
          change(null);
          setOpen(false);
        },
        children: selectedItem ? getObjectValue(selectedItem, optionEcho) : null
      }
    },
    dropdown: /*#__PURE__*/React.createElement(DropdownList, {
      width: (_triggerNode$offsetWi = triggerNode === null || triggerNode === void 0 ? void 0 : triggerNode.offsetWidth) !== null && _triggerNode$offsetWi !== void 0 ? _triggerNode$offsetWi : 0,
      maxHeight: dropdownHeight
    }, /*#__PURE__*/React.createElement(SelectOptions, searchProps, options.map(function (item) {
      var value = getValue(item);
      var disabled = isOptionDisabled(item);
      return /*#__PURE__*/React.createElement(DropdownOption, {
        key: value,
        onClick: function onClick() {
          if (disabled) {
            return;
          }

          change(value);
          setOpen(false);
        },
        selected: selected === value,
        disabled: disabled
      }, optionRender(item));
    })))
  };
});